<div
  class="mat-container"
  [ngClass]="{
    'mat-container-training': modifying,
  }"
>
  <mat-table [dataSource]="procedureTrainingsDS" class="mb-2">
    <ng-container matColumnDef="procedure">
      <mat-header-cell *matHeaderCellDef>
        <span>{{ getMessage("ALSPC_RolesCatalog_Procedure").description }}</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let e" class="px-2">
        <span
          [matTooltip]="
            e?.procedureMaster?.procedure?.status == 0
              ? 'Procedure is Inactive'
              : !e?.id || e.id == 0
                ? 'Pending Approval'
                : ''
          "
          [ngClass]="{
            inactive: e?.procedureMaster?.procedure?.status == 0,
            pending: !e?.id || e.id == 0,
          }"
        >
          {{
            e?.procedureMaster?.procedure?.procedureNumber +
              " - " +
              e?.procedureMaster?.procedure?.title
          }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="obligation">
      <mat-header-cell *matHeaderCellDef>
        <span>{{
          getMessage("ALSPC_RolesCatalog_Obligation").description
        }}</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let e" class="px-2">
        <mat-select
          matNativeControl
          name="obligationType"
          (selectionChange)="updateTraining()"
          [(ngModel)]="e.obligationType"
          [disabled]="!(adding || modifying)"
        >
          <mat-option [value]="1">
            <span>Recommended</span>
          </mat-option>
          <mat-option [value]="2">
            <span>Required - Read Only</span>
          </mat-option>
          <mat-option [value]="3">
            <span>Required - Follow Up</span>
          </mat-option>
        </mat-select>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="delete">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let e" class="px-2">
        <button
          mat-icon-button
          color="warn"
          (click)="deleteTraining(e)"
          [disabled]="!(adding || modifying)"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <mat-header-row
      *matHeaderRowDef="trainingColumns; sticky: true"
    ></mat-header-row>
    <mat-row
      *matRowDef="let row; columns: trainingColumns"
      class="p-0"
    ></mat-row>
  </mat-table>
</div>
<procedure-autocomplete
  *ngIf="active && (adding || modifying)"
  #procedureAutocomplete
  [placeholder]="getMessage('ALSPC_RolesCatalog_AddProcedure').description"
  [disabled]="false"
  [selectedProcedures]="selectedProcedures"
  (select)="createTraining($event)"
>
</procedure-autocomplete>
